import React, { useState, useEffect, useCallback } from "react";
import {
  CommonHeader,
  EmptyListPage,
  ErrorSuccessModal,
  TableLoader,
  ConfirmationModal,
} from "../../../components/commons";
import { CustomerSupplier } from "../../../assets/images";
import { connect } from "react-redux";
import { RootState } from "../../../redux/rootReducers";
import {
  changeCustomerSupplierStatusAction,
  getAllCustomerSupplierAction,
  getCustomerSupplierGroupingListAction,
  getSingleCustomerSupplierAction,
  resetClientSettingsError,
  resetClientSettingsSuccess,
  resetCustomerSupplierGroupingList,
  resetCustomerSupplierGroupingTotalCount,
  resetCustomerSupplierList,
  resetCustomerSupplierListTotal,
  resetMessage,
} from "../../../redux/clientSettings";
import { CustomerSupplierListType } from "../../../redux/clientSettings/clientSettingTypes";
import CustomerSupplierTable from "../../../components/ClientSettings/CustomerSupplierManager/CustomerSupplierTable/CustomerSupplierTable";
import { CUSTOMER_SUPPLIER_HEADER } from "../../../constant/tableHeadersConstants/clientSettingsconstants/customerSupplierHeader";
import { resetSession } from "../../../redux/auth";
import { SearchIcon } from "../../../components/Icon";
import {
  ChangeStatusCustomerSupplierPayloadType,
  GetAllCustomerSupplierListPayloadType,
  GetCustomerSupplierGroupingListPayloadType,
  GetSingleCustomerSupplierListPayloadType,
} from "../../../commonTypes/clientSettingsTypes";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";
import useDebounce from "../../../customHooks/useDebounce";
import CustomerSupplierFilter, {
  CUSTOMER_TYPE_STATUS_RADIO_OPTIONS,
} from "./CustomerSupplierFilter";
import MultiSelect from "../../../components/commons/MultiSelect";
import { RadioTypes } from "../../../commonTypes/universalTypes";
import { Link, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import LedgerDownloadModal from "../../../components/commons/LedgerDownloadModal";
import { GetLedgerStatementPdfType } from "../../../commonTypes/reportsTypes";
import { formatDate } from "../../../utils/commonFunctions";
import { getLedgerStatementPdfApi } from "../../../apis/reportsApis";
import FileSaver from "file-saver";

export type LedgerPdfDataType = {
  ledger_id: number | null;
  legal_name: string | null;
};

type AppProps = {
  history: any;
  token: string | null;
  fetching: boolean;
  success: number | null;
  error: string | null;
  statusCode: number | null;
  companyName: string;
  message: string | null;
  dispatchResetCustomerSupplierListAction: () => void;
  dispatchResetClientSettingsError: () => void;
  dispatchResetCustomerSupplierListTotal: () => void;
  dispatchResetClientSettingsSuccessAction: () => void;
  dispatchGetAllCustomerSupplierGroupingAction: (
    data: GetCustomerSupplierGroupingListPayloadType
  ) => void;
  dispatchResetSession: () => void;
  customerSupplierList: [] | CustomerSupplierListType[];
  customerSupplierListTotal: string | number;
  singleCustomerSupplier: CustomerSupplierListType;
  dispatchGetSingleCustomerSupplierAction: (
    data: GetSingleCustomerSupplierListPayloadType
  ) => void;
  dispatchChangeCustomerSupplierStatusAction: (
    data: ChangeStatusCustomerSupplierPayloadType
  ) => void;
  dispatchResetCustomerSupplierMessage: () => void;
};

const CustomerSupplierManager = ({
  history,
  token,
  fetching,
  success,
  error,
  message,
  statusCode,
  customerSupplierList,
  companyName,
  customerSupplierListTotal,
  dispatchGetAllCustomerSupplierGroupingAction,
  dispatchResetClientSettingsError,
  dispatchResetClientSettingsSuccessAction,
  dispatchResetCustomerSupplierListAction,
  dispatchResetSession,
  singleCustomerSupplier,
  dispatchResetCustomerSupplierListTotal,
  dispatchGetSingleCustomerSupplierAction,
  dispatchChangeCustomerSupplierStatusAction,
  dispatchResetCustomerSupplierMessage,
}: AppProps) => {
  const persistSearch = history?.location?.state?.searchData;
  const { id }: any = useParams();
  const company_name = history?.location?.state?.company_name
    ? history?.location?.state?.company_name
    : companyName;
  const client_code = history?.location?.state?.client_code
    ? history?.location?.state?.client_code
    : id;
  const [searchData, setSearchData] = useState(persistSearch);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(20);
  const [searchClear, setSearchClear] = useState(false);
  const [data, setData] = useState<[] | any[]>([]);
  const [typeStatus, setTypeStatus] = useState<any>("");
  const [typeStatusValue, setTypeStatusValue] = useState<string>("");
  const [clearFilter, setClearFilter] = useState<boolean>(false);
  const [multiSelectData, setMultiSelectData] = useState<any>([]);
  const [
    showLedgerStatementDownloadModal,
    setShowLedgerStatementDownloadModal,
  ] = useState<boolean>(false);
  const [showConfirmationModal, setShowConfirmationModal] =
    useState<boolean>(false);
  const [isMultiSelectPresent, setIsMultiSelectPresent] =
    useState<boolean>(false);
  const [confirmationModalData, setConfirmationModalData] = useState<any>({
    legal_name: "",
    is_disabled: null,
    ledger_id: "",
    ledger_number: "",
  });

  const [ledgerPdfData, setLedgerPdfData] = useState<LedgerPdfDataType>({
    ledger_id: null,
    legal_name: null,
  });

  const [ledgerPdfDownloadButton, setLedgerPdfDownloadButton] =
    useState<boolean>(false);

  const [ledgerPdfStartDate, setLedgerPdfStartDate] = useState("");
  const [ledgerPdfEndDate, setLedgerPdfEndDate] = useState("");

  //=======================User Management============================================
  const [isAddCustomerSupplierPresent, setIsAddCustomerSupplierPresent] =
    useMenuCheck();
  const [isEditCustomerSupplierPresent, setIsEditCustomerSupplierPresent] =
    useMenuCheck();
  const [
    isChangeStatusCustomerSupplierPresent,
    setIsChangeStatusCustomerSupplierPresent,
  ] = useMenuCheck();
  const [isBulkUploadCustomerSupplierPresent, setIsCustomerSupplierBulkUploadPresent] =
    useMenuCheck();
  //==================================================================================

  let persistFilterCustomerSupplier = history?.location?.state?.filterData;

  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
    });
    dispatchResetClientSettingsError();
    dispatchResetCustomerSupplierMessage();
    dispatchResetClientSettingsSuccessAction();
    dispatchResetCustomerSupplierListAction();
    // dispatchRresetCustomerSupplierListTotal();
    setIsAddCustomerSupplierPresent("Add Customer/Supplier", "menu");
    setIsEditCustomerSupplierPresent("Edit Customer/Supplier", "menu");
    setIsChangeStatusCustomerSupplierPresent("Disable Ledgers", "menu");
    setIsCustomerSupplierBulkUploadPresent("Bulk Upload Customers/Suppliers", "menu");

    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (persistFilterCustomerSupplier?.typeStatus) {
      setTypeStatus(persistFilterCustomerSupplier?.typeStatus);
      setMultiSelectData(persistFilterCustomerSupplier?.multiSelectData);
      setIsMultiSelectPresent(
        persistFilterCustomerSupplier?.isMultiSelectPresent
      );
      setClearFilter(false);
      setTypeStatusValue(persistFilterCustomerSupplier?.typeStatus);
    }
  }, [persistFilterCustomerSupplier]);

  useEffect(() => {
    if (
      message?.includes("has been disabled successfully!") ||
      message?.includes("has been enabled successfully!")
    ) {
      dispatchResetCustomerSupplierListAction();
      dispatchResetClientSettingsError();
      dispatchResetCustomerSupplierMessage();
      toast.success(
        `Customer/Supplier ${
          confirmationModalData?.is_disabled === 0 ? "disable" : "enable"
        } successfully!`,
        {
          duration: 2000,
        }
      );
      let finalData = {
        token,
        clientCode: client_code,
        offset: 0,
        limit,
        search_term: searchData,
        type: typeStatus
          ? typeStatus
          : persistFilterCustomerSupplier?.typeStatus,
      };
      if (offset === 0) {
        dispatchGetAllCustomerSupplierGroupingAction(finalData);
      } else {
        setOffset(0);
      }
    }
    //eslint-disable-next-line
  }, [message]);

  useEffect(() => {
    if (token && client_code) {
      let finalData = {
        token,
        clientCode: client_code,
        limit: limit,
        offset,
        search_term: searchData,
        type: typeStatus
          ? typeStatus
          : persistFilterCustomerSupplier?.typeStatus,
      };
      if (clearFilter) {
        finalData.type = "";
        setTypeStatus("");
        setTypeStatusValue("");
        setClearFilter(false);
      }
      if (offset < +customerSupplierListTotal) {
        dispatchGetAllCustomerSupplierGroupingAction(finalData);
      } else if (
        (offset === 0 && customerSupplierListTotal === "") ||
        customerSupplierListTotal == 0
      ) {
        dispatchGetAllCustomerSupplierGroupingAction(finalData);
      }
    }
    //eslint-disable-next-line
  }, [offset, clearFilter]);

  useEffect(() => {
    if (clearFilter) {
      persistFilterCustomerSupplier = {};
      delete history?.location?.state?.filterData;
    }
  }, [clearFilter]);

  const fetchNewData = () => {
    if (token && client_code) {
      let finalData = {
        token,
        clientCode: client_code,
        offset,
        limit,
        search_term: searchData,
        type: typeStatus
          ? typeStatus
          : persistFilterCustomerSupplier?.typeStatus,
      };
      if (token) {
        if (offset === 0) {
          dispatchGetAllCustomerSupplierGroupingAction(finalData);

          setOffset(0);
        } else {
          setOffset(0);
        }
      }
    }
  };

  useEffect(() => {
    if (searchClear) {
      let finalData = {
        token,
        clientCode: client_code,
        offset,
        limit,
        search_term: searchData,
        type: typeStatus
          ? typeStatus
          : persistFilterCustomerSupplier?.typeStatus,
      };
      if (searchData?.length === 0) {
        dispatchGetAllCustomerSupplierGroupingAction(finalData);

        setOffset(0);
      }
    }
    //eslint-disable-next-line
  }, [searchClear, searchData]);

  // Custom Hook for debounce function
  useDebounce(
    () => {
      if (searchData) {
        fetchNewData();
      }
    },
    500,
    [searchData]
  );

  useEffect(() => {
    dispatchResetCustomerSupplierListAction();
    getData();
    setOffset(0);
    setIsMultiSelectPresent(true);
    if (
      (typeStatus && isMultiSelectPresent) ||
      (!typeStatus && isMultiSelectPresent)
    ) {
      if (offset === 0 && token) {
        let finalData = {
          token,
          limit,
          clientCode: client_code,
          offset,
          search_term: searchData,
          type: typeStatus
            ? typeStatus
            : persistFilterCustomerSupplier?.typeStatus,
        };
        dispatchGetAllCustomerSupplierGroupingAction(finalData);
      }
    }
    //eslint-disable-next-line
  }, [typeStatus]);

  const getData = useCallback(() => {
    const getTypeStatusValue = CUSTOMER_TYPE_STATUS_RADIO_OPTIONS.find(
      (item: RadioTypes) => String(item.id) === String(typeStatus)
    );
    setMultiSelectData([getTypeStatusValue]);
  }, [typeStatus]);

  const handleSearch = (e: any) => {
    let value = e.target.value;
    setSearchData(value);

    if (value?.length === 0) {
      let finalData = {
        offset: 0,
        limit: 10,
        token,
        clientCode: client_code,
        type: typeStatus
          ? typeStatus
          : persistFilterCustomerSupplier?.typeStatus,
      };
      dispatchGetAllCustomerSupplierGroupingAction(finalData);
    }
  };

  const handleRedirectToBulkUpload=()=>{
    history.push({
      pathname:`/client-settings/customers-suppliers/bulk-upload/${client_code}`,
      state:{
        client_code,company_name
      }
    })
  }
  //infinite Scroll

  const onScroll = () => {
    const scrollTop = document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = document.documentElement.clientHeight;
    if (Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight) {
      setOffset(offset + limit);
    }
  };

  const resetData = () => {
    dispatchResetCustomerSupplierListAction();
    dispatchResetCustomerSupplierListTotal();
    setData([]);
    setOffset(0);
  };

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
    //eslint-disable-next-line
  }, [customerSupplierList]);

  useEffect(() => {
    if (customerSupplierList?.length === 0) {
      setData(customerSupplierList);
    } else if (offset > 0) {
      setData((prv: any) => [...prv, ...customerSupplierList]);
    } else {
      setData(customerSupplierList);
    }
    //eslint-disable-next-line
  }, [customerSupplierList]);

  const handleRedirectToAddForm = () => {
    history.push({
      pathname: `/client-settings/customers-suppliers/add/${client_code}`,
      state: { company_name, client_code },
    });
  };

  const onClose = (id: any) => {
    const checkActiveStatusValue = CUSTOMER_TYPE_STATUS_RADIO_OPTIONS.find(
      (item: RadioTypes) => item._id == id
    );
    persistFilterCustomerSupplier = {};
    delete history?.location?.state?.filterData;
    if (checkActiveStatusValue) {
      setTypeStatus("");
      setTypeStatusValue("");
    }
  };

  const handleRedirectToEditForm = (data: CustomerSupplierListType) => {
    if (client_code) {
      const finalData = {
        token,
        client_code,
        customerSupplierId: data?.ledger_id,
      };
      dispatchGetSingleCustomerSupplierAction(finalData);
    }
    window.scrollTo(0, 0);
    history.push({
      pathname: `/client-settings/customers-suppliers/edit/${client_code}/${data?.ledger_id}`,
      state: {
        data: singleCustomerSupplier,
        company_name,
        client_code,
        isEdit,
        filterData: { typeStatus, multiSelectData, isMultiSelectPresent },
        searchData,
      },
    });
  };

  useEffect(() => {
    setIsEdit(() => true);
  }, [handleRedirectToEditForm]);

  const handleChangeCustomerSupplierStatus = (currentData: any) => {
    if (token && confirmationModalData?.ledger_id) {
      let updateData = {
        token,
        client_code: client_code,
        ledger_id: confirmationModalData?.ledger_id,
        is_disabled: confirmationModalData?.is_disabled === 0 ? 1 : 0,
      };
      dispatchChangeCustomerSupplierStatusAction(updateData);
    }
  };
  const handleEnableDisableStatus = (data: any) => {
    setShowConfirmationModal(true);
    setLedgerPdfDownloadButton(false);
    setConfirmationModalData({ ...data });
  };
  const handleConfirmationModal = () => {
    setShowConfirmationModal(!showConfirmationModal);
  };

  const handleLedgerStatementDownloadModal = () => {
    setLedgerPdfDownloadButton(false);
    setShowLedgerStatementDownloadModal(!showLedgerStatementDownloadModal);
  };

  const handleSetLedgerStatementEmailData = (data: LedgerPdfDataType) => {
    setLedgerPdfStartDate("");
    setLedgerPdfEndDate("");
    setLedgerPdfData(data);
  };

  const handleLedgerStatementPdfStartDate = (date: string) => {
    if (date === "Invalid date") date = "";
    setLedgerPdfStartDate(date);
    if (ledgerPdfStartDate !== date) {
      setLedgerPdfEndDate("");
    }
  };

  const handleLedgerStatementPdfEndDate = (date: string) => {
    if (date === "Invalid date") date = "";
    setLedgerPdfEndDate(date);
  };

  const handleDownloadLedgerStatementPdf = () => {
    setLedgerPdfDownloadButton(true);
    let finalData: GetLedgerStatementPdfType = {
      token,
      ledger_id: ledgerPdfData?.ledger_id,
      client_code,
      start_date: formatDate(ledgerPdfStartDate),
      end_date: formatDate(ledgerPdfEndDate),
    };

    if (
      token &&
      finalData?.ledger_id &&
      finalData?.client_code &&
      finalData?.start_date &&
      finalData?.end_date
    ) {
      let legalName = ledgerPdfData?.legal_name;
      let pdfName = `${legalName}_${finalData?.start_date}_${finalData?.end_date}`;

      getLedgerStatementPdfApi(finalData).then((response: any) => {
        let blob = new Blob([response.data], {
          type: "application/pdf",
        });

        FileSaver.saveAs(blob, pdfName);
        setShowLedgerStatementDownloadModal(false);
        setLedgerPdfStartDate("");
        setLedgerPdfEndDate("");
        setLedgerPdfDownloadButton(false);
        toast.success("Ledger Statement Downloaded Successfully!", {
          duration: 3000,
        });
      });
    }
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetClientSettingsError();
            }}
          />
        );
      }
    }
    /*FUTURE USE */
    // else if (success === 1 && !message?.includes(" has been disabled successfully!")) {
    //   return (
    //     <ErrorSuccessModal
    //       type="success"
    //       isOpen={success === 1}
    //       title="Success"
    //       message={`Business Address Added Successfully!`}
    //       buttonText="OK"
    //       onPress={() => {
    //         dispatchResetClientSettingsSuccessAction();
    //         history.goBack();
    //       }}
    //       statusCode={statusCode}
    //     />
    //   );
    // }

    return false;
  };

  return (
    <div className="row">
      <div className="col-md-6 mb-3">
        <CommonHeader
          title={`Customers/Suppliers List`}
          company_name={company_name}
          client_code={client_code}
        />
      </div>
      {customerSupplierList?.length && isAddCustomerSupplierPresent ? (
        <div className="col-md-6 text-right">
          <button className="btn btn-primary" onClick={handleRedirectToAddForm}>
            + Add Customer/Supplier
          </button>
        </div>
      ) : null}
      <div className="col-md-12 mt-4">
        <div className="new-table-card">
          <div className="header">
            <div className="left-header">
              <div className="heading"> Customer/Supplier List</div>
              {!fetching && (
                <div
                  className="sub-heading"
                  style={{ marginTop: "-22px" }}
                >{`Total ${
                  customerSupplierListTotal ? customerSupplierListTotal : 0
                } entries found`}</div>
              )}
              <div>
                <MultiSelect data={multiSelectData} onClose={onClose} />
              </div>
            </div>
            <div
              className="text-right d-flex flex-row col-lg-7"
              style={{ justifyContent: "flex-end", marginLeft: "70px" }}
            >
              {isBulkUploadCustomerSupplierPresent && (
              <div
              onClick={() => handleRedirectToBulkUpload()}
              className="btn btn-outline mr-2"
                style={{
                  width: "200px",
                  height: "38px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >

                  <i className="fas fa-file-upload"></i>
                    &nbsp;Bulk&nbsp;Upload

            </div>
              )}

              <div className="mr-2 w-auto position-relative">
                <span
                  style={{ position: "absolute", top: "8px", left: "25px" }}
                >
                  <SearchIcon />
                </span>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Search Customer/Supplier"
                  onChange={(e) => handleSearch(e)}
                  style={{ paddingLeft: "45px" }}
                  value={searchData}
                />
              </div>
              <div className="form-group mr-1">
                <CustomerSupplierFilter
                  typeStatus={typeStatus}
                  setTypeStatus={setTypeStatus}
                  typeStatusValue={typeStatusValue}
                  setTypeStatusValue={setTypeStatusValue}
                  setClearFilter={setClearFilter}
                  setOffset={setOffset}
                  setData={setData}
                  resetData={resetData}
                />
              </div>
            </div>
          </div>
          <>
            {fetching && offset == 0 ? (
              <TableLoader Rows={10} ColumnPerRow={7} />
            ) : customerSupplierList?.length > 0 ? (
              <CustomerSupplierTable
                fetching={fetching}
                data={data}
                headers={
                  isChangeStatusCustomerSupplierPresent
                    ? CUSTOMER_SUPPLIER_HEADER
                    : CUSTOMER_SUPPLIER_HEADER?.filter(
                        (e) => e?.value != "status"
                      )
                }
                handleRedirectToEditForm={handleRedirectToEditForm}
                isEdit={isEdit}
                isEditCustomerSupplierPresent={isEditCustomerSupplierPresent}
                offset={offset}
                handleEnableDisableStatus={handleEnableDisableStatus}
                isChangeStatusCustomerSupplierPresent={
                  isChangeStatusCustomerSupplierPresent
                }
                handleLedgerStatementDownloadModal={
                  handleLedgerStatementDownloadModal
                }
                handleSetLedgerStatementEmailData={
                  handleSetLedgerStatementEmailData
                }
              />
            ) : (
              <>
                {!fetching && data?.length === 0 && (
                  <EmptyListPage
                    title="No Supplier/Customer Found!"
                    text="Add your suppliers or customers and manage the list here"
                    buttonTitle="+ Add Customer/Supplier"
                    showLinkButton
                    link={`/client-settings/customers-suppliers/add/${client_code}`}
                    company_name={company_name}
                    client_code={client_code}
                    image={CustomerSupplier}
                    imageWidth="30%"
                  />
                )}
              </>
            )}
          </>
        </div>
      </div>
      {showConfirmationModal && confirmationModalData?.ledger_id && (
        <ConfirmationModal
          toggle={() => {
            handleConfirmationModal();
          }}
          isOpen={showConfirmationModal}
          title={`${
            !confirmationModalData?.is_disabled ? "Disable" : "Enable"
          } Customer/Supplier ?`}
          message={`Are you sure you want to ${
            !confirmationModalData?.is_disabled ? `Disable ` : `Enable`
          }?`}
          confirmButtonText={
            confirmationModalData?.is_disabled ? "Enable" : "Disable"
          }
          onPressConfirm={() => {
            handleChangeCustomerSupplierStatus(confirmationModalData);
            handleConfirmationModal();
          }}
        />
      )}
      {showLedgerStatementDownloadModal && (
        <LedgerDownloadModal
          isOpen={showLedgerStatementDownloadModal}
          handleLedgerStatementDownloadModal={
            handleLedgerStatementDownloadModal
          }
          handleDownloadLedgerStatementPdf={handleDownloadLedgerStatementPdf}
          ledgerPdfData={ledgerPdfData}
          ledgerPdfStartDate={ledgerPdfStartDate}
          ledgerPdfEndDate={ledgerPdfEndDate}
          handleLedgerStatementPdfStartDate={handleLedgerStatementPdfStartDate}
          handleLedgerStatementPdfEndDate={handleLedgerStatementPdfEndDate}
          ledgerPdfDownloadButton={ledgerPdfDownloadButton}
        />
      )}
      {handleErrorModal()}
    </div>
  );
};

const mapStateTopProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.clientSettings.fetching,
  success: state.clientSettings.success,
  error: state.clientSettings.error,
  message: state.clientSettings.message,
  statusCode: state.clientSettings.statusCode,
  companyName: state.auth.companyName,
  customerSupplierList: state.clientSettings.customerSupplierGroupingList,
  customerSupplierListTotal: state.clientSettings.customerSupplierGroupingTotalCount,
  singleCustomerSupplier: state.clientSettings.singleCustomerSupplier,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetCustomerSupplierListAction: () =>
    dispatch(resetCustomerSupplierGroupingList()),
  dispatchResetClientSettingsError: () => dispatch(resetClientSettingsError()),
  dispatchResetClientSettingsSuccessAction: () =>
    dispatch(resetClientSettingsSuccess()),
  dispatchResetCustomerSupplierMessage: () => dispatch(resetMessage()),
  dispatchGetAllCustomerSupplierGroupingAction: (
    data: GetCustomerSupplierGroupingListPayloadType
  ) => dispatch(getCustomerSupplierGroupingListAction(data)),
  dispatchGetSingleCustomerSupplierAction: (
    data: GetSingleCustomerSupplierListPayloadType
  ) => dispatch(getSingleCustomerSupplierAction(data)),
  //
  dispatchChangeCustomerSupplierStatusAction: (
    data: ChangeStatusCustomerSupplierPayloadType
  ) => dispatch(changeCustomerSupplierStatusAction(data)),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetCustomerSupplierListTotal: () =>
    dispatch(resetCustomerSupplierGroupingTotalCount()),
});

export default connect(
  mapStateTopProps,
  mapDispatchToProps
)(CustomerSupplierManager);
